import React from 'react'
import './gradientcircle.css'

function GradientCircle() {
  return (
    <div className='gradientcircles'>
        <div className='gradientcircle gradient-circle-div1'>
        </div>
        <div className='gradientcircle gradient-circle-div2'>
        </div>
        <div className='gradientcircle gradient-circle-div3'>
        </div>
        <div className='gradientcircle gradient-circle-div4'>
        </div>
        <div className='gradientcircle gradient-circle-div5'>
        </div>
        <div className='gradientcircle gradient-circle-div6'>
        </div>
    </div>
  )
}

export default GradientCircle
